import {Injectable} from "@angular/core";
import {EventManagementService} from "./event-management.service";
import {SharedService} from "./shared.service";
import {from, Observable, of} from 'rxjs';
import {catchError, map} from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class RegistrationManagersService {

  entities: any[];

  constructor(private EMS: EventManagementService, private sharedService: SharedService) {
  }

  getRegistrationManagers(managerName: string): Observable<string[]> {
    return this.EMS.get('/v1/registration_managers', {
      'manager_name': managerName
    }).pipe(
      map((resp) => resp.data as string[]),
      catchError((err) => {
        this.popError('Error getting registration managers', err);
        return of([]);
      })
    );
  }


  popError(msg: string, err: any) {
    this.sharedService.popError(msg);
    console.dir(msg + ": ");
    console.log(err);
  }
}
